import { DatePicker, FilterModal } from "components"
import { Select } from "components2"
import { useFormikContext } from "formik"
import { DateConvert } from "utilities"
import { useDropdownUrgensi } from "../hooks"

export const ModalFilterListPermintaanPerubahanData = ({ isToggle, toggle }) => {
  const { values, handleSubmit, setValues } = useFormikContext()

  const dropdownUrgensi = useDropdownUrgensi()

  const onTanggalChange = (
    dates,
    values,
    setValues,
    value_awal,
    value_akhir
  ) => {
    const [start, end] = dates
    const startDate = start ? DateConvert(start).default : null
    const endDate = end ? DateConvert(end).default : null

    setValues({
      ...values,
      [value_awal]: startDate,
      [value_akhir]: endDate,
    })
  }

  // HANDLE CHANGE
  const onResetButtonClick = (setValues) => {
    const myPromise = new Promise((resolve) => {
      setValues({
        tgl_mulai: undefined,
        tgl_selesai: undefined,
        urgensi: undefined,
      })

      setTimeout(() => resolve(), 300)
    })

    myPromise.then(() => { })
  }

  return (
    <FilterModal
      isToggle={isToggle}
      toggleModal={toggle}
      onResetButtonClick={() => onResetButtonClick(setValues)}
      onFilterButtonClick={handleSubmit}
    >
      <DatePicker
        selectsRange
        label="Tgl. Permintaan Perubahan Data"
        placeholderText="Pilih Tgl. Permintaan Perubahan Data"
        startDate={
          values?.tgl_mulai
            ? new Date(values?.tgl_mulai)
            : ""
        }
        endDate={
          values?.tgl_selesai
            ? new Date(values?.tgl_selesai)
            : ""
        }
        onChange={(dates) =>
          onTanggalChange(
            dates,
            values,
            setValues,
            "tgl_mulai",
            "tgl_selesai"
          )
        }
        monthsShown={2}
      />

      <Select
        label="Urgensi"
        placeholder="Pilih urgensi"
        name="urgensi"
        options={dropdownUrgensi.data ?? []}
        onChange={async (val) =>
          setValues({
            ...values,
            urgensi: val.value,
          })
        }
        defaultValue={dropdownUrgensi.data?.find(
          (val) => val.value === values.urgensi
        )}
      />
    </FilterModal>
  )
}
